// Style for html returned from the StayWell patient article UCR.
const patientArticleStyle = `
    .footer-element {
        font-family: Roboto;
        font-size: 12px;
        font-weight: 400;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.67;
        letter-spacing: 0.4px;
        color: #637387;
        margin-top: 25px;
        margin-bottom: 55px;
    };
`;

// Due to the fact the patient article html isn't jsx and doesn't use className and instead uses class
// we have to concatenate a style css block to the html we pass into dangerouslySetInnerHTML.
// Regular typescript css module with webpack class name transform won't work with regular html 'class' names.
const addPatientArticleStyleToHtml = (documentHtml: string) => {
    var style = `<style>
        ${patientArticleStyle}
    </style>`;

    var articleHtml = style + documentHtml;
    return articleHtml;
};

const services = {
    addPatientArticleStyleToHtml,
};

export default services;
